const validator = ({
  trigger,
  pristine,
  initialized,
  syncValidationPasses,
}) => {
  if (!syncValidationPasses) {
    return false
  }

  switch (trigger) {
    case 'blur':
    case 'change':
      return true

    case 'submit':
      // submitting, so only async validate if form is dirty or was never initialized
      // conversely, DON'T async validate if the form is pristine just as it was initialized
      return pristine || initialized
    //return true

    default:
      return false
  }
}

export default validator
